import React from "react";
import { Star } from "lucide-react";

const Reviews = ({ reviews = [] }) => {
  return (
    <section id="avis" data-testid="reviews-section" className="py-28 md:py-36 relative">
      <div className="max-w-[1400px] mx-auto px-6 md:px-12">
        <div className="text-center mb-20">
          <p className="label-caps text-[color:var(--gold)] mb-6">Témoignages</p>
          <h2 className="font-serif text-4xl md:text-5xl lg:text-6xl text-white">
            La voix de nos <em className="italic text-[color:var(--gold-soft)]">connaisseurs</em>
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-10 md:gap-14">
          {reviews.slice(0, 6).map((r, i) => (
            <article
              key={r.id}
              data-testid={`review-card-${i}`}
              className="reveal border-t border-white/10 pt-10"
              style={{ animationDelay: `${i * 120}ms` }}
            >
              <div className="flex gap-1 mb-6">
                {Array.from({ length: r.rating }).map((_, k) => (
                  <Star key={k} size={14} className="fill-[color:var(--gold)] text-[color:var(--gold)]" />
                ))}
              </div>
              <h3 className="font-serif text-2xl text-white mb-4">« {r.title} »</h3>
              <p className="text-white/60 font-light leading-relaxed mb-8">{r.body}</p>
              <div className="label-caps text-white/40 text-[10px]">
                {r.author} — {r.location}
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Reviews;
